import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { EmptyView } from '../EmptyView/index.jsx';
import { useGetLocationsQuery } from '../../store/api/sensors';
import { resetSecondarySensor } from '../../store/slices/sensors';
import { goToChartsSoil } from '../../utils/common';

const SoilSensor = ({ t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentWorkspaceId } = useSelector((state) => state.workspaces);
  const { selectedDate } = useSelector((state) => state.sensors);
  const [locationsWithSoilSensor, setLocationsWithSoilSensor] = useState(null);
  const {
    data: locations,
    isSuccess: isLocationsSuccess,
    isError: isLocationsError,
    isFetching: isLocationsLoading,
    error: cropsError,
  } = useGetLocationsQuery({}, { skip: !currentWorkspaceId, refetchOnMountOrArgChange: true });

  useEffect(() => {
    if (!isLocationsSuccess || !locations) return;

    const locationsFiltered = [...locations].filter((obj) =>
      obj.sensor.settings.enabled.find((prop) => prop.name === 'pair_soil_sensor'),
    );
    setLocationsWithSoilSensor(locationsFiltered);
    if (locationsFiltered.length > 0) {
      dispatch(resetSecondarySensor());
      goToChartsSoil({ id: locationsFiltered[0].id, date: selectedDate, navigate });
    }
  }, [isLocationsSuccess, locations]);

  return (
    isLocationsSuccess &&
    locationsWithSoilSensor &&
    locationsWithSoilSensor.length === 0 && (
      <EmptyView message={t('soil.emptyText')} title={t('soil.emptyTitle')} showRequestButton={true} t={t} />
    )
  );
};

export default SoilSensor;
